export default "__VITE_ASSET__d0a0ea9a__"